import { formatPesoAmount } from '../../utils/money';
import React from 'react';
import { normalizePriceRuleSelection } from '../../utils/complexPriceRules';
import { formatActiveRule, getEffectiveCost } from './quickPriceListModel';

export const temporaryPriceMoney = (value) => value == null || !Number.isFinite(Number(value))
  ? 'Sin dato' : `$${formatPesoAmount(Number(value))}`;

export const getTemporaryPriceMargin = (price, cost, quantity = 1) => {
  const amount = Number(price);
  const count = Number(quantity);
  if (!Number.isSafeInteger(amount) || amount <= 0 || amount > 2147483647
    || !Number.isFinite(count) || count <= 0 || cost == null
    || !Number.isFinite(Number(cost)) || Number(cost) < 0) return null;
  const totalCost = Number(cost) * count;
  const margin = amount - totalCost;
  return { totalCost, amount: margin, percent: totalCost > 0 ? margin / totalCost * 100 : null };
};

const ruleLabel = (format) => {
  const analysis = format?.analysis?.priceRule;
  const selection = normalizePriceRuleSelection(format?.priceRule ?? analysis?.selection, format?.stockPriceRule);
  if (selection?.type === 'complex') return [
    `Regla compleja: ${analysis?.complexPriceRule?.name || `#${selection.complexPriceRuleId}`}`,
    formatActiveRule(analysis?.resolvedRule),
  ].filter(Boolean).join(' · ');
  return formatActiveRule(selection?.rule) || 'Sin regla';
};

export const TemporaryPriceMargin = ({ price, cost, quantity = 1, quantityUnit = 'unidades de venta' }) => {
  if (String(price ?? '').trim() === '') return null;
  const margin = getTemporaryPriceMargin(price, cost, quantity);
  if (!margin) return <p className="mt-2 text-xs text-slate-500">Margen no disponible: ingresa un precio válido y verifica el costo del formato.</p>;
  return <div aria-live="polite" className={`mt-2 text-sm ${margin.amount < 0 ? 'text-red-700' : 'text-emerald-800'}`}>
    {Number(quantity) !== 1 && <p>Costo total de {Number(quantity).toLocaleString('es-CL')} {quantityUnit}: <strong>{temporaryPriceMoney(margin.totalCost)}</strong></p>}
    <p>Margen{Number(quantity) !== 1 ? ' total' : ''}: <strong>{temporaryPriceMoney(margin.amount)}</strong>
      {' · '}{margin.percent == null ? 'Porcentaje no calculable con costo $0' : <><strong>{margin.percent.toLocaleString('es-CL', { maximumFractionDigits: 2 })}%</strong> sobre el costo</>}
      {margin.amount < 0 && ' · Bajo costo'}</p>
  </div>;
};

const TemporaryPriceSummary = ({ target, format = target.format || target, price, quantity = 1, quantityUnit }) => {
  const cost = getEffectiveCost(format).effective;
  return <div className="min-w-0 text-sm text-slate-800">
    <p className="font-semibold">{target.label || `Formato ${target.id}`}</p>
    <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-2">
      <div><dt className="text-xs text-slate-600">Costo por {format?.metricUnit || 'unidad de venta'}</dt><dd className="font-bold">{cost == null ? 'Sin costo de referencia' : temporaryPriceMoney(cost)}</dd></div>
      <div><dt className="text-xs text-slate-600">Precio actual</dt><dd className="font-bold">{temporaryPriceMoney(format?.effectiveSellingPrice ?? format?.sellingPrice)}</dd></div>
      <div className="col-span-2"><dt className="text-xs text-slate-600">Regla de precio</dt><dd>{ruleLabel(format)}</dd></div>
    </dl>
    <TemporaryPriceMargin price={price} cost={cost} quantity={quantity} quantityUnit={quantityUnit} />
  </div>;
};

export default TemporaryPriceSummary;
